import { Component, Inject, TemplateRef, ViewChild, ViewEncapsulation } from "@angular/core";

import { MAT_DIALOG_DATA, MatDialog, MatDialogRef, } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";

import { FormControl } from "@angular/forms";
import { fuseAnimations } from "@fuse/animations";
import { map, Observable } from "rxjs";

import { BaseComponent } from "app/base-module/base-component/base.component";

import { AuthService } from "app/base-module/base-service/auth.service";
import { UsuarioService } from "app/base-module/base-service/usuario.service";
import { UtilitesService } from "app/base-module/base-service/utilites.service";
import { ClienteModel } from "app/clientes/models/cliente.model";
import { ClienteService } from "app/clientes/services/cliente.service";
import { EscritorioService } from "app/empreendimento/services/escritorio.service";
import { Escritorio } from "app/empresas/models/escritorio.model";
import { ServicoModel } from "app/empresas/models/servico.model";
import { ServicoService } from "app/empresas/services/servico.service";
import { Usuario } from "app/usuarios/models/user.model";
import { AtividadeAssunto } from "../models/atividade-assunto.model";
import { ListaAtividadeAssuntoService } from "../services/lista-atividade-assunto.service";
import { FiltroAtividadesData } from "./filtro-atividades.types";

@Component({
    selector: "filtro-atividades",
    templateUrl: "./filtro-atividades.component.html",
    styleUrls: ["./filtro-atividades.component.scss"],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
    providers: [ClienteService, EscritorioService, ServicoService],
})
export class FiltroAtividadesComponent extends BaseComponent {
    primeiroDia = this._utilitesService.primeiroDiaMes();
    ultimoDiaMesSeguinte = this._utilitesService.ultimoDiaMesSeguinte();
    horaAtual = this._utilitesService.hora();

    cliente = new FormControl(this.data?.cliente_id ?? "");
    assessor_id = new FormControl(this.data?.assessor_id ?? "");
    especialista_id = new FormControl(this.data?.especialista_id ?? "");
    escritorio_id = new FormControl(this.data?.escritorio_id ?? "");
    assunto_id = new FormControl(this.data?.assunto_id ?? "");
    servico_id = new FormControl(this.data?.servico_id ?? "");
    atividade_concluidas = new FormControl(this.data?.atividade_concluidas ?? "false");
    data_operacao_inicio = new FormControl(this.data?.data_operacao_inicio ? new Date(`${this.data.data_operacao_inicio} ${this.horaAtual}`) : this.primeiroDia);
    data_operacao_fim = new FormControl(this.data?.data_operacao_fim ? new Date(`${this.data.data_operacao_fim} ${this.horaAtual}`) : this.ultimoDiaMesSeguinte);

    loadingSpinner!: boolean;
    loadingSpinnerAssunto: boolean = false;
    loadingSpinnerAssessor: boolean = false;
    loadingSpinnerEspecialista: boolean = false;
    loadingSpinnerEscritorio: boolean = false;
    loadingSpinnerServico: boolean = false;

    filteredOptions!: Observable<ClienteModel[]>;
    listAssessor: Usuario[] = [];
    listEspecialista: Usuario[] = [];
    listEscritorios: Escritorio[] = [];
    listAssunto: AtividadeAssunto[] = [];
    listServicos: ServicoModel[] = [];
    usuario: Usuario;
    titulo: string;

    @ViewChild("addButtonTmpl", { static: false })
    addButtonTmpl!: TemplateRef<any>;
    @ViewChild(FiltroAtividadesComponent, { static: false })
    table!: FiltroAtividadesComponent;

    constructor(
        public dialog: MatDialog,
        override snackBar: MatSnackBar,
        public dialogRef: MatDialogRef<FiltroAtividadesComponent>,
        private _clienteService: ClienteService,
        private usuarioService: UsuarioService,
        private _authService: AuthService,
        public _escritorioService: EscritorioService,
        private _utilitesService: UtilitesService,
        public _assuntoAtividadeService: ListaAtividadeAssuntoService,
        private _servicoService: ServicoService,
        @Inject(MAT_DIALOG_DATA) public data: FiltroAtividadesData
    ) {
        super(dialog, snackBar);

        const strUser = this._authService.getUser();
        this.usuario = JSON.parse(strUser ? strUser : "{}") as Usuario;

        this.cliente.valueChanges.subscribe((query) => {
            if (typeof query === "string" || typeof query === "number") {
                this.loadingSpinner = true;
                this.params.search = query;
                this.filteredOptions = this._clienteService.search(this.params).pipe(map(response => response.data));
            }
        });

        this.getAllEscritorios();
        this.getAssessores();
        this.getAllAssuntos();

        if (!this.data?.is_assessor) {
            this.getAllServicos();
        }

        this.titulo = "Filtrar Atividades";
    }

    displayFn(cliente: any): string {
        if (cliente) {
            return cliente.nome;
        }
        return "";
    }

    getCliente(cliente: any): void {
        this.loadingSpinner = false;
    }

    onNoClick(): void {
        this.dialogRef.close("cancel");
    }

    selectEscritorio(event: any) {
        this.escritorio_id.setValue(event.value);
        this.getAssessores(event.value);
    }

    filtrar(): void {
        let inic = null;
        if (this.data_operacao_inicio.value != null) {
            inic = this._utilitesService.formatDateToString(
                this.data_operacao_inicio.value ?? new Date()
            );
        }

        let fim = null;
        if (this.data_operacao_fim.value != null) {
            fim = this._utilitesService.formatDateToString(
                this.data_operacao_fim.value ?? new Date()
            );
        }

        this.dialogRef.close({
            cliente: this.cliente.value,
            escritorio_id: this.escritorio_id.value,
            assessor_id: this.assessor_id.value,
            especialista_id: this.especialista_id.value,
            assunto_id: this.assunto_id.value,
            servico_id: this.servico_id.value,
            data_operacao_inicio: inic,
            data_operacao_fim: fim,
            atividade_concluidas: this.atividade_concluidas.value,
        });
    }

    getAssessores(escritorio_id = "") {
        this.loadingSpinnerAssessor = true;
        this.loadingSpinnerEspecialista = true;
        this.usuarioService
            .getLista({ escritorio_id: escritorio_id })
            .subscribe(
                (resquest) => {
                    this.listAssessor = resquest.data ?? [];
                    this.listEspecialista = resquest.data ?? [];
                },
                (error) => {
                    this.loadingSpinnerAssessor = false;
                    this.loadingSpinnerEspecialista = false;
                },
                () => {
                    this.loadingSpinnerAssessor = false;
                    this.loadingSpinnerEspecialista = false;
                }
            );
    }

    getAllEscritorios() {
        this.loadingSpinnerEscritorio = true;
        this._escritorioService.getAllList({ no_paginate: true }).subscribe(
            (list) => {
                this.listEscritorios = list.data ?? [];
            },
            (error) => {
                this.loadingSpinnerEscritorio = false;
            },
            () => {
                this.loadingSpinnerEscritorio = false;
            }
        );
    }

    getAllAssuntos() {
        this.loadingSpinnerAssunto = true;
        this._assuntoAtividadeService
            .getLista({})
            .subscribe(
                (list) => {
                    this.listAssunto = list.data;
                },
                (error) => {
                    this.loadingSpinnerAssunto = false;
                },
                () => {
                    this.loadingSpinnerAssunto = false;
                }
            );
    }

    getAllServicos() {
        this.loadingSpinnerServico = true;
        this._servicoService.getLista().subscribe({
            next: (list) => {
                this.listServicos = list.data ?? [];
            },
            error: (error) => {
                this.loadingSpinnerServico = false;
                this.showError(error.error?.message || "Erro ao carregar serviços");
            },
            complete: () => {
                this.loadingSpinnerServico = false;
            },
        });
    }
}
